module.exports = __webpack_public_path__ + "static/media/sell_make_6a.caa5f9db.png";